import { PaymentMethodACH } from "@/api/opb/opbTypes";
import {
  CardLogo,
  Tag,
  TagVariant,
  TextButton,
} from "@industriousoffice/react-components";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

interface ACHInfoProps {
  paymentMethod: PaymentMethodACH;
  withEdit?: boolean;
  footer?: ReactNode;
}

export function ACHInfo({ paymentMethod, withEdit, footer }: ACHInfoProps) {
  const { t } = useTranslation("paymentMethods");

  return (
    <>
      <div className="pt-1 grow-0">
        <CardLogo cardType="ACH" />
      </div>
      <div className="pl-3 text-left relative grow shrink-0 w-24 flex-wrap">
        <div>{paymentMethod.nickname || null}</div>
        <div className="flex items-center">
          <div className="capitalize">{paymentMethod.bankAccountType}</div>
          {paymentMethod.default && (
            <Tag
              text={t("Default")}
              variant={TagVariant.Info}
              className="mx-2 rounded-sm font-normal h-5"
            />
          )}
        </div>
        <div>
          <span className="font-bold">{paymentMethod.bankName}</span>
          {paymentMethod.bankAccountNumber}
        </div>
        {withEdit ? (
          <TextButton
            type="button"
            className="absolute top-1 right-3"
            testId={`ach-edit_${paymentMethod.id}-btn`}
          >
            {t("Edit")}
          </TextButton>
        ) : null}
        {footer}
      </div>
    </>
  );
}
